// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2280":"8fbb0865","6070":"dca8211e","6186":"f571b80c","8254":"e40fcfd1","9862":"8d152481"}[chunkId] + ".chunk.css";
};